import { InjectionToken } from '@angular/core';
import { DatastoreConfig } from './datastore.interface';

export const DATASTORE_CONFIG = new InjectionToken<DatastoreConfig>(
  'DatastoreConfig',
);



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/datastore.config.ts